module.exports = __webpack_public_path__ + "assets/xiangmu.10f934d9e53a1a9990b20095ebee5917.png";